export default __webpack_public_path__ + "static/Week-4-City Sweetheart-Homepage-Banner-desktop-1620ca08bc56bd6e23f8359ff1ea87b7.webp";